import { useMemo } from "react";

import useTableSort from "components/Table/useTableSort";

import {
  INITIAL_SORT_DIRECTION,
  INITIAL_SORT_OPTION,
  MODULE_VERSION_TEST_CASES_TABLE_FILTERS_STORAGE_KEY,
  SORT_CONFIG,
} from "./constants";
import { sortModuleVersionTestCases } from "./helpers";
import { ModuleVersionTestCaseRow } from "./types";

export const useSortingModuleVersionTestCases = (testCases: ModuleVersionTestCaseRow[] = []) => {
  const { sortDescriptor } = useTableSort({
    filtersOrderSettingsKey: MODULE_VERSION_TEST_CASES_TABLE_FILTERS_STORAGE_KEY,
    sortConfig: SORT_CONFIG,
    initialSortOption: INITIAL_SORT_OPTION,
    initialSortDirection: INITIAL_SORT_DIRECTION,
  });

  return useMemo(
    () => sortModuleVersionTestCases(testCases, sortDescriptor),
    [testCases, sortDescriptor]
  );
};
